export default "<div class=\"environment-switcher\" [class.is-prod]=\"isProd()\">Using {{ getEnvName() }}</div>\n"